var _style, _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrLp06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160.546,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".B{fill:none}.C{clip-rule:evenodd}.D{clip-path:url(#B)}.E{clip-path:url(#H)}.F{fill:#212b3e}.G{fill:rgba(0,0,0,0.16)}.H{clip-path:url(#D)}.I{clip-path:url(#S)}.J{clip-path:url(#U)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.143-259a32,32,0,0,1,32,32v3.523a6.859,6.859,0,0,1,5.714,6.762v8a6.859,6.859,0,0,1-5.889,6.789,32.022,32.022,0,0,1-18.11,25.56v10.508h2.286a41.143,41.143,0,0,1,41.143,41.143v5.143H32v-5.143a41.143,41.143,0,0,1,41.143-41.143h2.286v-10.508a32.023,32.023,0,0,1-18.111-25.56,6.858,6.858,0,0,1-5.889-6.789v-8a6.859,6.859,0,0,1,5.714-6.762V-227A32,32,0,0,1,89.143-259Z",
    transform: "translate(-32 259)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1167,704.148h926.287V-1753H-1167Z",
    transform: "translate(1167 1753)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h114.444v140.453H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32-119.571H146.286V-259H32Z",
    transform: "translate(-32 259)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76-165a32,32,0,0,0,32,32,32,32,0,0,0,32-32h0v4.571a32,32,0,0,1-32,32,32,32,0,0,1-32-32Z",
    transform: "translate(-76 165)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.858-111.929c10.343,1.157,18.285,4.339,18.285,12.575l0-.247a41.154,41.154,0,0,1,25.146,37.917v5.143H32v-5.143A41.155,41.155,0,0,1,57.146-99.6c.157-8.053,8.043-11.182,18.282-12.328v10.817A13.714,13.714,0,0,0,89.143-87.4a13.714,13.714,0,0,0,13.714-13.714h0Z",
    transform: "translate(-32 111.929)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h114.444v57.222H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32-56.571H146.286V-112H32Z",
    transform: "translate(-32 112)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99-64.8v27.578h-4V-66.85a36.88 36.88 0 0 0 4 2.05zm38.287-2.051v23.058a2 2 0 1 1-4 0V-64.8c1.373-.602 2.709-1.287 3.999-2.051z",
    transform: "translate(-94.999 66.851)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.952-112.275c8.6,1.627,14.548,4.868,14.548,11.19,0,11.264-18.879,20.4-38,20.4s-38-9.131-38-20.4c0-6.323,5.948-9.564,14.548-11.19-5.191,1.914-8.548,5.132-8.548,10.487,0,11.653,15.9,21.1,32,21.1s32-9.446,32-21.1c0-5.244-3.219-8.438-8.228-10.366Z",
    transform: "translate(-65.5 112.275)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89-24.63c15.311-4.306 31.073-6.807 46.965-7.452.621-.025 1.144.349 1.144.816a.96.96 0 0 1-1.022.813c-4.785.2-25.535 1.3-44.4 5.824 0 .07-2.683.417-2.683 0m42.212-16.876c.291-.615.658-1.191 1.094-1.713.1.052-.12.8-.7 1.808a12.49 12.49 0 0 1-1.709 2.3c.12-.294.871-1.618 1.316-2.395m-31.488.8c.361-.063.732.01 1.042.206.43.322.747.772.906 1.286a2.39 2.39 0 0 1-.513 1.75c-.41.577-.905 1.491-1.144 1.915-.154.282-.343.437-.667.153-.261-.195-.413-.502-.41-.828a3.61 3.61 0 0 1 .786-1.8c.427-.661.888-1.44.649-1.572-.632-.357-4.374 2.536-4.459 4.426-.052 1.085 2.289 1.708 2.955 2.078a.9.9 0 0 1 .513.765c-.068.524-.302 1.013-.667 1.395-.604.649-1.427 1.052-2.311 1.131a5.33 5.33 0 0 1-4.255-1.6c-.239-.247-.119-.442.12-.555a2.56 2.56 0 0 1 .53-.119 1.99 1.99 0 0 1 1.332.233c.798.618 1.776.96 2.785.973.336-.023.655-.157.907-.38a.43.43 0 0 0-.018-.684c-1.23-.752-3.6-1.322-3.6-2.988 0-2.221 2.665-4.516 4.2-5.34.404-.235.85-.387 1.313-.447zm32.018-3.924c.324-.353.632-.491.957-.24.359.259.57.676.563 1.119a2.19 2.19 0 0 1-.1.7c-.75 2.124-2.104 3.983-3.895 5.348a6.74 6.74 0 0 0-.564 2.214c0 .392.1.656.325.627.786-.1 1.777-1.329 2.426-2.59.05-.105.123-.198.214-.271a26.45 26.45 0 0 1 1.221-1.764c-.192-.125-.312-.334-.324-.562.153-.954.758-1.776 1.623-2.206.359-.047.512.129.512.5-.036.462-.14.915-.307 1.347.506-.211.974-.504 1.384-.868.291-.234.461-.289.683-.106a1.39 1.39 0 0 1 .5.98 1.12 1.12 0 0 1-.273.672c-.922 1.135-1.9 2.553-1.9 3.517 0 .425.137.668.376.636.581-.076 1.265-1.08 1.794-2.278.137-.312.376-.36.53-.086.136.347.118.736-.051 1.069a3.3 3.3 0 0 1-2.391 1.949 1.3 1.3 0 0 1-1.606-1.373c0-1.045.905-2.423 1.76-3.532a4.1 4.1 0 0 1-1.247.426c-1.032 1.588-1.87 3.294-2.495 5.082-.068.3-.29.479-.6.209a1.07 1.07 0 0 1-.407-.7c-.415.3-.895.499-1.4.583a1.3 1.3 0 0 1-1.6-.86c-.572.731-1.385 1.235-2.294 1.423-1.162.153-1.794-.368-1.794-1.25a2.78 2.78 0 0 1 .256-1.1c.273-.592.838-1.548 1.23-2.188.376-.589.786-1.133.649-1.115s-.5.228-1.5 1.325c-1.211 1.405-2.181 3.001-2.87 4.723-.171.334-.41.414-.683.188a.95.95 0 0 1-.376-.849 4.23 4.23 0 0 1 .308-1.25 17.4 17.4 0 0 1 1.263-2.322c.462-.8.94-1.48.786-1.459a6 6 0 0 0-1.827 1.678c-1.019 1.298-1.837 2.742-2.427 4.283-.12.278-.308.4-.6.194a.93.93 0 0 1-.294-.325 3.19 3.19 0 0 1-1.534.73c-1.008.133-1.522-.274-1.589-1a3.7 3.7 0 0 1-2.221 1.42c-.454.117-.925-.122-1.1-.557a3.72 3.72 0 0 1-1.924 1 1.36 1.36 0 0 1-1.692-1.46 8.25 8.25 0 0 1 1.846-3.706c-.419.222-.868.38-1.333.47-1.23 2.775-3.144 5.248-5.314 5.534A1.9 1.9 0 0 1 100-32.625a4.56 4.56 0 0 1 .512-1.946c.906-1.786 2.255-2.878 3.246-3.009.201-.038.408-.02.6.052.413.151.767.432 1.008.8.256.489-.017 1.113-.343 1.793a6.03 6.03 0 0 0-.307.71c-.12.359-.188.449-.615.293-.37-.125-.614-.478-.6-.868.075-.42.207-.828.393-1.212.17-.366.341-.715.256-.769-.223-.134-1.316 1.007-2.033 2.489-.301.584-.476 1.226-.513 1.882 0 .686.291 1.1.786 1.072 1.674-.156 3.5-2.781 4.39-4.907a.62.62 0 0 1-.478-.655 3.11 3.11 0 0 1 1.709-2.3c.359-.047.5.147.5.506a5.19 5.19 0 0 1-.324 1.415c.543-.214 1.046-.518 1.487-.9.256-.213.53-.315.752-.116.297.268.471.648.479 1.048a1.11 1.11 0 0 1-.291.692 10.67 10.67 0 0 0-1.845 2.987 2.39 2.39 0 0 0-.137.753c0 .408.137.635.393.618.541-.025 1.417-1.045 1.95-2.15a21.45 21.45 0 0 1 2.288-4.338.45.45 0 0 1 .735-.1c.172.199.263.455.256.718 0 .67-1.248 2.729-1.845 4.066-.308.694-.359 1.3.017 1.255.444-.059 1.35-1.288 2.221-2.71 1.008-1.7 1.452-2.87 2.066-3.7.24-.342.513-.443.718-.193a1.2 1.2 0 0 1 .256.816c-.134.846-.461 1.65-.957 2.348a7.5 7.5 0 0 0-1.161 2.668c0 .295.1.444.325.415.413-.054.99-.737 1.512-1.534.727-1.733 1.593-3.405 2.588-5 .222-.339.478-.358.649-.086a1.35 1.35 0 0 1 .239.753c-.002.151-.019.301-.052.448a5.35 5.35 0 0 1 2.239-1.6c.546-.072.905.469.905 1.155a5.15 5.15 0 0 1 2.221-1.485c.5-.049.768.356.768.9a5.54 5.54 0 0 1-1.059 2.475 4.92 4.92 0 0 0-.923 2.114c0 .376.171.615.445.58.53-.07 1.366-1.324 2-2.4a.65.65 0 0 1 .133-.168c.849-2.822 2.273-5.438 4.183-7.682z",
    transform: "translate(-89 45)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118-146a8,8,0,0,0,8,8h0a8,8,0,0,0,8-8",
    transform: "translate(-118 146)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120-165c0,2.525,3.07,4.571,6.857,4.571h0c3.787,0,6.857-2.047,6.857-4.571",
    transform: "translate(-120 165)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.092-178.113c1.195 2.306 3.596 3.734 6.193 3.684a6.83 6.83 0 0 0 6.182-3.661c.315-.641-.133-1.166-.586-.777a8.6 8.6 0 0 1-5.6 1.956c-1.978.029-3.907-.622-5.463-1.844-.506-.417-1.035.007-.726.642z",
    transform: "translate(-92 179)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.092-178.113c1.195 2.306 3.596 3.734 6.193 3.684a6.83 6.83 0 0 0 6.182-3.661c.315-.641-.133-1.166-.586-.777a8.6 8.6 0 0 1-5.6 1.956c-1.978.029-3.907-.622-5.463-1.844-.506-.417-1.035.007-.726.642z",
    transform: "translate(-150 179)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.036-203.805c2.569-3.615,8.007-5.433,13.575-3.638a1.143,1.143,0,0,0,1.438-.737,1.143,1.143,0,0,0-.737-1.438c-6.519-2.1-12.994.063-16.139,4.489a1.143,1.143,0,0,0,.27,1.594A1.143,1.143,0,0,0,90.036-203.805Z",
    transform: "translate(-87.961 210.428)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.076-196.591c-2.237-3.148-8.37-4.913-13.653-3.616a1.143,1.143,0,0,1-1.382-.837,1.143,1.143,0,0,1,.837-1.382c6.135-1.507,13.237.537,16.061,4.511a1.143,1.143,0,0,1-.269,1.594A1.143,1.143,0,0,1,161.076-196.591Z",
    transform: "translate(-146.007 202.923)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-135H150.857V-295H0Z",
    transform: "translate(0 295)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h115.744v152.158H0z",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.571-272.548c11.374-8.434,30.538-10.868,37.17-.844,4.943-2.2,12.269-.195,17.687,4.844,5.466,5.38,9.829,17.257,7.232,26.975q.091,1.084.091,2.191V-226.9a6.863,6.863,0,0,0-5.608-5.557v-.095h0c-3.45-12.307-13.585-17.955-19.756-23.557-9.651,10.8-39.774,10.837-49.958,32.129h0v5.714a6.859,6.859,0,0,0,5.834,6.781,32.017,32.017,0,0,0,18.166,26.139v.222h0c1.675,25.06-3.8,56.456-39.429,46.857,7.8-4.562,11.912-33.839,12-51.836v-50.423a26.37,26.37,0,0,1,.657-5.866A40.455,40.455,0,0,1,67.571-272.548Zm62.18,55.491v.778a57.143,57.143,0,0,0,6.264,26.013l15.4,30.119a21.718,21.718,0,0,1-2.25,23.3,41.145,41.145,0,0,0-41.022-37.983h-2.286v-10.508a32.018,32.018,0,0,0,18.166-26.139A6.863,6.863,0,0,0,129.752-217.058Z",
    transform: "translate(-39 279.946)",
    className: "B C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32-128.571H150.857V-280H32Z",
    transform: "translate(-32 280)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39-128.571H153.857V-280H39Z",
    transform: "translate(-39 280)",
    className: "B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.958-238.225c6.171,5.6,16.307,11.25,19.756,23.557l-.023-.082c-3.471-10.625-13.574-14.377-19.731-19.228-9.654,9.371-39.776,9.4-49.96,27.881h0c10.075-21.063,39.661-21.326,49.641-31.783Z",
    transform: "translate(-66 238.225)",
    className: "B C"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c000ff",
    d: "M0 0h160v160H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.429 21.117)",
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-685.144 -853.716)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(685.065 853.322)",
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.079 .394)",
    className: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h115.429v140.572H-.571z",
    fill: "#cfc6ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h115.429v140.572H-.571z",
    fill: "#d08a5a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.222 54.109)",
    clipPath: "url(#E)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.143 -53.714)",
    className: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.571 53.143h65.143v37.714H24.571z",
    fill: "rgba(0,0,0,0.1)"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.429 105.158)",
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-685.144 -937.757)",
    className: "D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(685.065 936.553)",
    clipPath: "url(#G)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.079 1.163)",
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h115.429v56.572H-.571z",
    fill: "#b7c1da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h115.429v56.572H-.571z",
    fill: "#0057ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.078 26.962)",
    clipPath: "url(#I)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36 -25.8)",
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.429 25.228h43.43V56h-43.43z",
    fill: "#f3f3f3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.222 1.005)",
    clipPath: "url(#J)",
    className: "G"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.143 .157)",
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.571-.571h77.143v32.572H18.571z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.65 39.448)",
    clipPath: "url(#K)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.571 -38.286)",
    className: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 37.592h49.761v18.409H32z",
    fill: "#fff"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.572 85.689)",
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-734.287 -918.287)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.716 917.716h17.143v9.143h-17.143z",
    fill: "rgba(255,255,255,0.8)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.715 74.832)",
    clipPath: "url(#M)",
    className: "G"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-735.43 -907.43)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M734.859 906.859h14.857v5.714h-14.857z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.715 66.832)",
    clipPath: "url(#N)",
    className: "F"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-719.43 -899.43)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M718.641 904.574h14.141v-5.97h-14.141z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.857 66.832)",
    clipPath: "url(#O)",
    className: "F"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-752.573 -899.43)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M751.784 904.574h14.141v-5.97h-14.141z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.407 48.873)",
    clipPath: "url(#P)",
    className: "F"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-717.122 -881.471)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.396 879.607h18.579v9.69h-18.579z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.576 53.162)",
    clipPath: "url(#Q)",
    className: "F"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-750.291 -885.76)",
    className: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M749.601 893.298h18.56v-9.12h-18.56z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.143 .546)",
    clipPath: "url(#R)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.108 8.473)",
    className: "I"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.177 .129)",
    clipPath: "url(#T)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -.031)",
    className: "J"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.822 -.098)",
    className: "I"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.178 .098)",
    clipPath: "url(#V)",
    fill: "#242b3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h116v152.572h-116z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.571-.571h116v152.572h-116z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.606 23.97)",
    clipPath: "url(#W)",
    className: "G"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.429 -23.871)",
    className: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.857 23.3h70.857v33.272H18.857z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrLp06);
export default __webpack_public_path__ + "static/media/scrumlr-lp-06.7bf10bcc87fffea954d6c6c29ed6da95.svg";
export { ForwardRef as ReactComponent };